interface Props {
  label?: string;
}

export function Loading({ label = "Carregando..." }: Props) {
  return (
    <div className="flex items-center justify-center py-12 text-slate-500">
      <span className="animate-pulse">{label}</span>
    </div>
  );
}

interface ErrorProps {
  error: unknown;
}

export function ErrorBox({ error }: ErrorProps) {
  const message = error instanceof Error ? error.message : String(error);
  return (
    <div className="rounded border border-red-200 bg-red-50 text-red-700 px-4 py-3">
      <strong className="block mb-1">Algo deu errado</strong>
      <span className="text-sm">{message}</span>
    </div>
  );
}
